import PropTypes from "prop-types";
import { CtaGrid, FeatureBlock } from "@lululemon/dsp-legacy-shared";
import { CLASSES_EVENTS } from "../../content/analytics-tags";

import styles from "./sweat-with-us.module.scss";

const SweatWithUs = ({ content }) => {
  const featureBlocks = (
    <div className={styles.featureBlocksContainer}>
      {content.featureBlocks.map((item) => (
        <FeatureBlock
          key={item.title}
          title={item.title}
          blurb={item.blurb}
          iconContent={item.iconContent}
          isEmbeddedBlurb={item.isEmbeddedBlurb}
        />
      ))}
    </div>
  );

  return (
    <CtaGrid
      heading={content.heading}
      description={content.description}
      cta={content.cta}
      ctaAlignBottom
      rightPanel={featureBlocks}
      linkAttributes={{
        "data-component-link": CLASSES_EVENTS
      }}
    />
  );
};

SweatWithUs.propTypes = {
  content: PropTypes.shape({
    heading: PropTypes.string,
    description: PropTypes.string,
    featureBlocks: PropTypes.arrayOf(PropTypes.object),
    // eslint-disable-next-line react/forbid-prop-types
    cta: PropTypes.object
  })
};

SweatWithUs.defaultProps = {
  content: {}
};

export default SweatWithUs;
